<script setup lang="ts">
import { RouterView } from 'vue-router'
import { pageKey } from '@/router/pageKey'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'

const authStore = useAuthStore()

onMounted(async () => {
  // Try to restore session from stored token
  await authStore.checkAuth()
})
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <component :is="Component" :key="pageKey(route)" />
  </RouterView>
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
